import { render, staticRenderFns } from "./myAward.vue?vue&type=template&id=77c5a9ac&scoped=true&"
import script from "./myAward.vue?vue&type=script&lang=js&"
export * from "./myAward.vue?vue&type=script&lang=js&"
import style0 from "./myAward.vue?vue&type=style&index=0&id=77c5a9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5a9ac",
  null
  
)

export default component.exports